import { useResi3DStore } from "@common/features/Residences3D/state/resi3DStore";
import { useFavoritesStore } from "@state/favouritesStore";
import styled from "styled-components/macro";
import React, { useCallback } from "react";
import { HeartFilledIcon, HeartIcon } from "@radix-ui/react-icons";

const TableRow = ({
  cells,
  row,
  rowIndex,
  isSelected,
  onClick,
  columns,
  onPointerOver,
  onPointerOut,
}: any) => {
  const hoveredUnit = useResi3DStore((s) => s.hoveredUnit);
  const hovered = hoveredUnit[0] === row.unitName;
  const { addToFavorites, isFavorite } = useFavoritesStore();

  const handleClick = useCallback(() => {
    if (onClick) onClick();
  }, [onClick]);

  const handlePointerOver = useCallback(() => {
    if (onPointerOver) onPointerOver();
  }, [onPointerOver]);

  const handlePointerOut = useCallback(() => {
    if (onPointerOut) onPointerOut();
  }, [onPointerOut]);

  return (
    <TableRowContainer
      hovered={hovered}
      onPointerOver={handlePointerOver}
      onPointerOut={handlePointerOut}
      className={`grid-table-row ${isSelected ? "selected" : ""}`}
      onClick={handleClick}
      columns={columns}
      id={row["unitName"]}
    >
      {cells.map((cell, index) => (
        <TableCell key={index}>
          {typeof cell === "object" && cell?.render !== undefined
            ? cell.render(row, rowIndex)
            : processCell(row, cell)}
        </TableCell>
      ))}
      <TableCell
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          addToFavorites(row);
        }}
      >
        {isFavorite(row) ? <HeartFilledIcon /> : <HeartIcon />}
      </TableCell>
    </TableRowContainer>
  );
};

export { TableRow };

const TableRowContainer = styled.div<{ columns: number; hovered: boolean }>`
  display: flex;
  justify-content: space-around;
  align-items: center;
  cursor: pointer;
  transition: 0.3s ease-in-out;
  font-size: 0.75rem;
  font-family: primaryFont;
  border-bottom: 1px solid var(--primary) !important;
  &:hover {
    opacity: 0.8;
    background-color: #ffffff5e;
  }

  background-color: #ffffff1a;
  padding: 0 0;
  color: var(--black);

  &.selected {
    opacity: 1;
    background-color: var(--accent);
    color: var(--black);
  }

  &:active {
    transform: scale(0.99);
    transition: 0.3s;
    opacity: 0.5;
  }
`;

const TableCell = styled.div`
  width: 100%;
  padding: 1rem 0;
  text-align: center;
  white-space: nowrap;
`;

export const poundFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "GBP",
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

function processCell(row, cell) {
  switch (cell) {
    case "id":
      return row["planType"];
    case "price":
      return row.price ? poundFormatter.format(row["price"]) : "Unreleased";
    case "unitType":
      return row[cell]
        .split(" ")
        .filter((txt) => txt !== "TYPE")
        .join("")
        .replace("1-STUDIO", "1-ST");
    case "aspect":
      return row[cell].replaceAll("c", "");
    case "beds":
      return row[cell] === 0 ? "Studio" : row[cell];
    case "baths":
      return row[cell] === 0 ? 1 : row[cell];
    case "floor":
      return row[cell] === "0" ? "GF" : row[cell];
    default:
      return row[cell];
  }
}
